import { FilterV2 } from "PFTypes/filters_v2";

export const getEmptyValue = (filter: Pick<FilterV2, "type">) => {
  if (filter.type === "string") {
    return "";
  }

  return null;
};
